import type { TiendaBaseConfigDTO } from "./types";

export interface TemplateConfigStorage {
    obtener(vchCacheKey: string): Promise<TiendaBaseConfigDTO | null>;
    guardar(vchCacheKey: string, config: TiendaBaseConfigDTO): Promise<void>;
    borrar(vchCacheKey: string): Promise<void>;
}

const VERSION_CACHE = "v2";
const PREFIX_CACHE = `tienda_base_template_${VERSION_CACHE}`;

const construirKey = (vchCacheKey: string) => `${PREFIX_CACHE}_${vchCacheKey}`;

const crearStorage = (area: () => Storage): TemplateConfigStorage => ({
    async obtener(vchCacheKey: string) {
        if (typeof window === "undefined") return null;
        const raw = area().getItem(construirKey(vchCacheKey));
        if (!raw) return null;
        try {
            return JSON.parse(raw) as TiendaBaseConfigDTO;
        } catch {
            area().removeItem(construirKey(vchCacheKey));
            return null;
        }
    },
    async guardar(vchCacheKey: string, config: TiendaBaseConfigDTO) {
        if (typeof window === "undefined") return;
        area().setItem(construirKey(vchCacheKey), JSON.stringify(config));
    },
    async borrar(vchCacheKey: string) {
        if (typeof window === "undefined") return;
        area().removeItem(construirKey(vchCacheKey));
    },
});

export const templateConfigStorageLocal: TemplateConfigStorage = crearStorage(
    () => window.localStorage,
);

export const TEMPLATE_CONFIG_CACHE_KEY = "config_actual";

const MOD_ESTILO_KEY = `${PREFIX_CACHE}_mod_estilo`;
const MOD_CONTENIDO_KEY = `${PREFIX_CACHE}_mod_contenido`;

export const templateModStorage = {
    getModEstilo: (): string | null =>
        typeof window !== "undefined" ? window.localStorage.getItem(MOD_ESTILO_KEY) : null,
    setModEstilo: (v: string) => {
        if (typeof window !== "undefined") window.localStorage.setItem(MOD_ESTILO_KEY, v);
    },
    getModContenido: (): string | null =>
        typeof window !== "undefined" ? window.localStorage.getItem(MOD_CONTENIDO_KEY) : null,
    setModContenido: (v: string) => {
        if (typeof window !== "undefined") window.localStorage.setItem(MOD_CONTENIDO_KEY, v);
    },
};
